import React from 'react';
import './styles.css';

export interface CardSectionProps {
  children: React.ReactNode;
  className?: string;
}

const CardSection: React.FC<CardSectionProps> = ({
  children,
  className = ''
}) => {
  const sectionClassName = ['card-section', className].filter(Boolean).join(' ');

  return (
    <div className={sectionClassName}>
      {children}
    </div>
  );
};

export default CardSection; 